export default {
      id: "login-mobile-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#login-mobile",
      toString: function () {
        return this.url;
      }
    }